export async function share(text: string): Promise<'shared' | 'copied' | 'failed'> {
  try {
    if (navigator.share) { await navigator.share({ text }); return 'shared' }
  } catch (e) { if ((e as Error).name === 'AbortError') return 'failed' }
  try { await navigator.clipboard.writeText(text); return 'copied' } catch { return 'failed' }
}

export function haptic(ms = 8) { try { navigator.vibrate?.(ms) } catch { /* no-op */ } }
